import { apiRequest } from "./common";

const getDocuments = async (type, pageNo, pageSize) => {
    const response = await apiRequest('get', `/student-document?page=${pageNo}&limit=${pageSize}&type=${type}`);
    return response.data;
};

const createDocument = async (data) => {
    const response = await apiRequest('post', `/student-document`, data);
    return response.data;
};

const updateDocument = async (id, data) => {
    const response = await apiRequest('put', `/student-document/${id}`, data);
    return response.data;
};

const deleteDocument = async (id) => {
    const response = await apiRequest('delete', `/student-document/${id}`);
    return response.data;
};

export {
    getDocuments,
    createDocument,
    updateDocument,
    deleteDocument
}